<template>
  <div class="app-container-v2 table-container-v2">
    <div class="title-box">
      <div class="title-left"></div>
      <div class="title-right">
        <el-button v-if="isHrUser" class="button-v2" type="primary" @click="add">上传</el-button>
      </div>
    </div>
    <div class="table-body flex vertical" v-loading="loading">
      <air-table
        ref="airTable"
        class="table-v2"
        :show-checkbox="true"
        align="center"
        :columns="customList"
        :data="tableData"
        @selection-change="handleSelectionChange"
      >
        <template #operation="{ row }">
          <div class="flex center">
            <span class="text-button" @click="handleDownload(row)">下载</span>
            <span class="text-button" v-if="isHrUser" @click="deleteRow(row)">删除</span>
          </div>
        </template>
      </air-table>
      <bsp-pagination
        :pager-config.sync="formInline"
        :current-page.sync="formInline.page"
        :page-size.sync="formInline.limit"
        @page-change="handleCurrentChange"
        @page-size-change="handleSizeChange"
        show-page-size
      />
    </div>
    <!-- 上传弹框 -->
    <el-dialog
      class="modal-v2 has-padding"
      ref="uploadDialog"
      v-dialogDrag
      title="上传工资报表"
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :visible.sync="addUpload"
      append-to-body
      width="600px"
    >
      <el-form class="form-v2 upload-modal" ref="form" :model="form" label-width="140px" :rules="rules">
        <el-form-item label="报表业务类型：" prop="reportType">
          <el-input v-model="form.reportType" placeholder="请输入报表业务类型" class="w100"/>
        </el-form-item>
        <el-form-item label="工资月份：" prop="wageMonth">
          <el-date-picker
            class="date-picker-v2 has-icon w100"
            v-model="form.wageMonth"
            type="month"
            format="yyyy-MM"
            value-format="yyyy-MM"
            placeholder="选择工资月份"
          />
        </el-form-item>
        <el-form-item label="备注：" prop="remark">
          <el-input
            v-model="form.remark"
            type="textarea"
            placeholder="请输入备注"
            :rows="3"
            class="w100"
          />
        </el-form-item>
        <el-form-item label="附件上传：" prop="uploadFile">
          <el-upload
            v-loading="uploadLoading"
            class="text-left"
            name="uploadFile"
            ref="upload"
            action="#"
            :before-upload="beforeFileUpload"
            :show-file-list="true"
            :http-request="fileUploadSuccess"
            :on-remove="handleRemove"
            :limit="1"
            drag
          >
            <div v-if="!uploadFlag">
              <i class="el-icon-upload"/>
              <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
              <div class="el-upload__tip" slot="tip">支持 .xls, .xlsx, .DOC, .DOCX, .zip 格式</div>
            </div>
            <el-button class="uploadFlag" type="success" icon="el-icon-check" circle v-else></el-button>
          </el-upload>
        </el-form-item>
      </el-form>
      <div slot="footer" class="w100 flex jbetween acenter">
        <div></div>
        <div class="flex acenter">
          <el-button class="button-v2" plain @click="close">取消</el-button>
          <el-button type="primary" class="button-v2" :loading="submitLoading" @click="_importExcel">确定</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {getFileList, downloadFile, deleteAttach, saveAttach} from "@/api/seagate/financeReport.js"
import {mapGetters} from 'vuex';
import {uploadSeagateFile} from "@/api/seagate/fileDownload";

export default {
  computed: {
    ...mapGetters([
      'userInfo'
    ])
  },
  created() {
    this.isHrUser = this.userInfo.userType !== '10620003';
    this._getLoadBatch();
  },
  data() {
    return {
      isHrUser: false,
      formInline: {
        limit: 20,
        page: 1,
        total: 0,
      },
      form: {
        reportType: '',
        wageMonth: '',
        remark: '',
        uploadFile: null
      },
      rules: {
        reportType: [{required: true, message: '请输入报表业务类型', trigger: 'blur'}],
        wageMonth: [{required: true, message: '请选择工资月份', trigger: 'change'}],
        remark: [{required: true, message: '请输入备注', trigger: 'blur'}],
        uploadFile: [{required: true, message: '请选择上传文件', trigger: 'change'}]
      },
      loading: false,
      uploadLoading: false,
      submitLoading: false,
      addUpload: false,
      tableData: [],
      multipleSelection: [],
      file: null,
      uploadFlag: false,
      customList: [
        {
          title: "工资月份",
          field: "wageMonth",
        },
        {
          title: "报表类型",
          field: "reportType"
        },
        {
          title: "附件名称",
          field: "fileName"
        },
        {
          title: "附件上传时间",
          field: "uploadTime",
        },
        {
          title: "最后一次下载时间",
          field: "lastDownTime",
        },
        {
          title: "下载次数",
          field: "downloadTimes",
        },
        {
          title: "备注",
          field: "remark",
        }
      ]
    };
  },
  methods: {
    add() {
      this.addUpload = true;
    },
    close() {
      this.addUpload = false;
      this.file = null;
      this.uploadFlag = false;
      this.form = {
        reportType: '',
        wageMonth: '',
        remark: '',
        uploadFile: null
      };
      this.$refs.upload.clearFiles();
      // 使用 $nextTick 确保在 DOM 更新周期后清除校验
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.clearValidate();
        }
      });
    },
    handleSizeChange() {
      this._getLoadBatch();
    },
    handleCurrentChange() {
      this._getLoadBatch();
    },
    handleSelectionChange(selection) {
      this.multipleSelection = selection;
    },
    deleteRow(row) {
      this.$confirm('您确定要删除该数据?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this._deleteFiles(row.id);
      }).catch(() => {
      });
    },
    _deleteFiles(id) {
      this.loading = true;
      let params = {id: id};
      deleteAttach(params).then(() => {
        this.$message.success('删除成功!');
        this._getLoadBatch();
        this.multipleSelection = [];
      }).catch(() => {
        this.$message.error('删除失败');
      }).finally(() => {
        this.loading = false;
      });
    },
    handleDownload(row) {
      this.loading = true
      let params = {
        id: row.id
      }
      downloadFile(params).then(res => {
        this.$downloadFile(res)
        this.$message.success('下载成功');
        this._getLoadBatch()
      }).catch(() => {
        this.$message.error('下载失败');
      }).finally(() => {
        this.loading = false;
      });
    },
    beforeFileUpload(file) {
      this.uploadLoading = true;
      const validExtensions = ['.xls', '.xlsx', '.DOC', '.DOCX', '.zip'];
      const fileName = file.name.toLowerCase();
      const isValidExtension = validExtensions.some(ext => fileName.endsWith(ext.toLowerCase()));

      if (!isValidExtension) {
        this.$message.error('导入文件只能是 .xls, .xlsx, .DOC, .DOCX, .zip 格式!');
        this.uploadLoading = false;
        return false;
      }

      const isLtM = file.size / 1024 / 1024 < 10;
      if (!isLtM) {
        this.$message.error('导入文件大小不能超过 10MB!');
        this.uploadLoading = false;
        return false;
      }

      this.file = file;
      this.form.uploadFile = this.file
      this.uploadFlag = true;
      this.uploadLoading = false;
      return isLtM && isValidExtension;
    },
    fileUploadSuccess() {
      this.uploadLoading = false;
      this.uploadFlag = true;
    },
    handleRemove() {
      this.file = null;
      this.uploadFlag = false;
    },
    _importExcel() {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return;
        }

        if (!this.file) {
          this.$message.warning('请选择上传文件');
          return;
        }

        this.submitLoading = true;
        const formData = new FormData();
        formData.append('uploadFile', this.file);
        formData.append('reportType', this.form.reportType);
        formData.append('wageMonth', this.form.wageMonth);
        formData.append('remark', this.form.remark);

        let loadingInstance = this.$loading({
          fullscreen: true, // 全屏
          text: '正在上传中，请稍候...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });


        saveAttach(formData).then((res) => {

          let messageFlag = res.data.messageFlag
          if(messageFlag == 'true') {
            this.$message.success('上传成功!');
            this.addUpload = false;
            this.submitLoading = false;
            this._getLoadBatch();
            this.close();
          }else {
            this.$message.error('上传失败:' + res.data.message);
          }

        }).catch(() => {
          this.$message.error('上传失败');
        }).finally(() => {
          this.submitLoading = false;
          loadingInstance.close()
        });
      });
    },
    _getLoadBatch() {
      this.loading = true;
      const params = {
        page: this.formInline.page,
        rows: this.formInline.limit,
        ...this.formInline
      };
      getFileList(params).then((res) => {
        this.tableData = res.data.records
        this.formInline.total = parseInt(res.data.total)
      }).catch(() => {
        this.$message.error('加载数据失败');
      }).finally(() => {
        this.loading = false;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.uploadFlag {
  font-size: 57px !important;
  background: #67C23A !important;
  margin: 52px 0 16px !important;
  line-height: 50px !important;
}

.text-button {
  padding: 0 5px;
}
.w100 {
  width: 100%;
}
</style>
